import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {SquareButton} from "@/scenes.ui/square-button";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import SpriteUtils from "@/utils/sprite-utils";
import {StringUtils} from "@/utils/string-utils";

export class BuyHammerPanel extends VerticalStandardPanel {

    private readonly DEPTH: number = 3000;
    private onAcceptCallback!: () => unknown;

    constructor(scene: Scene, canvas: HTMLCanvasElement, hammersCount:number, nextHammerPrice:number, onAcceptCallback: () => unknown) {
        super(scene, canvas, Tr('pokupka.molotka'));

        this.setDepth(this.DEPTH);

        this.onAcceptCallback = onAcceptCallback;

        let confirmationText = hammersCount + 1 < 5? StringUtils.formatString(Tr('buy.hammer.agitation'), hammersCount + 1) :
            StringUtils.formatString(Tr('buy.hammer.agitation2'), hammersCount + 1);

        let mainText = TextUtils.addTextByFamily(scene, confirmationText, 0, -15,
            '#ffd465', 16, 'normal', 400, Fonts.MYRIADPRO_BOLD);

        let hammerBg = SpriteUtils.addImage(this.scene, mainText.x, -150, Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_HAMMER_BG, 1.5);
        let hammer = SpriteUtils.addImage(this.scene, mainText.x, -150, Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_HAMMER, 1.5);

        let speedupButton = new SquareButton(this.scene, 0, 135, 0, Keys.UI_ART_GREEN_BUTTON,
            undefined, Keys.IC_100_MITHRIL, Tr('kupit'), false);

        speedupButton.setCallback(() => {
            if (this.isOnTop()) {
                if (this.onAcceptCallback != null) { this.onAcceptCallback(); }
                this.close();
            }
        });
        let speedupPriceText = TextUtils.addText(scene,
            String(nextHammerPrice), 0, 170, '#ffffff', 22, 'bold', 200);

        this.add([mainText, hammerBg, hammer, speedupButton, speedupPriceText]);

        //SpriteUtils.scale(this, 0.9);
    }
}
